import { Box } from '@mui/material';

/**
 * Image component for displaying images with customizable properties.
 *
 * @component
 * @param {Object} props - The properties that define the image.
 * @param {any} [props.height] - The height of the image. Defaults to '200px' if not provided.
 * @param {any} [props.width] - The width of the image. Defaults to '100vw' if not provided.
 * @param {string} [props.position] - The CSS position of the image. Defaults to 'relative' if not provided.
 * @param {number} [props.top] - The top position of the image. Defaults to 0 if not provided.
 * @param {string} [props.img] - The URL of the image to display.
 * @param {Object} [props.sx] - Additional styles to apply to the image using MUI's sx prop.
 * @param {Object} props.etc - Any additional props to pass to the underlying Box component.
 * @returns {React.Element} A Box component configured to display an image.
 */
const Image = ({
  height,
  width,
  position,
  top,
  img,
  sx = {},
  ...etc
}: {
  height?: any;
  width?: any;
  position?: string;
  top?: number;
  img?: string;
  sx?: any;
}) => {
  return (
    <Box
      component='img'
      sx={{
        width: width || '100vw',
        height: height || '200px',
        position: position || 'relative',
        top: top || 0,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundImage: `url(${img})`,
        objectFit: 'cover',
        objectPosition: 'center',
        ...sx,
      }}
      src={img}
      {...etc}
    />
  );
};

export default Image;
